export { default as insightQueries } from './basic'